import { common } from '@neo-one/client-common';
import { Hash256ContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
export class UInt256StackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asUInt256() {
        return this.value;
    }
    asBuffer() {
        return common.uInt256ToBuffer(this.value);
    }
    toContractParameter(_seen = new Set()) {
        return new Hash256ContractParameter(this.value);
    }
}

//# sourceMappingURL=UInt256StackItem.js.map
